import { useDispatch, useSelector } from 'react-redux';

import {
    analyticsCardRejectedClickDashboardFooter,
    analyticsCardRejectedClickShop,
} from '@perpay-web/fintech/actions/analytics/cardOnboardingMVP2';
import {
    analyticsCKPartnerHostedOnboardingRejectionScreen,
    analyticsCKPartnerHostedOnboardingApplicationRejectedClickDashboard,
    analyticsNonCKPartnerHostedOnboardingRejectionScreen,
    analyticsNonCKPartnerHostedOnboardingApplicationRejectedClickDashboard,
} from '@perpay-web/fintech/actions/analytics/partnerHostedOnboarding';
import CardRejectedSwitcher from '@perpay-web/fintech/components/screens/CardRejectedSwitcher/CardRejectedSwitcher';
import { getMarketplaceSpendingLimit } from '@perpay-web/fintech/dataModules/fetchCardAccountApplications';

const CardRejectedPassedKycContainer = ({ isPho }) => {
    const dispatch = useDispatch();
    const marketplaceSpendingLimit = useSelector(getMarketplaceSpendingLimit);

    const handlers = {
        onMountCreditKarma: () => {
            dispatch(analyticsCKPartnerHostedOnboardingRejectionScreen());
        },
        onClickDashboardCreditKarma: () => {
            dispatch(
                analyticsCKPartnerHostedOnboardingApplicationRejectedClickDashboard(),
            );
        },
        onMountNonCreditKarma: () => {
            dispatch(analyticsNonCKPartnerHostedOnboardingRejectionScreen());
        },
        onClickDashboardNonCreditKarma: () => {
            dispatch(
                analyticsNonCKPartnerHostedOnboardingApplicationRejectedClickDashboard(),
            );
        },
        onClickShop: () => {
            dispatch(analyticsCardRejectedClickShop());
        },
        onClickDashboard: () => {
            dispatch(analyticsCardRejectedClickDashboardFooter());
        },
    };

    return (
        <CardRejectedSwitcher
            isPho={isPho}
            marketplaceSpendingLimit={marketplaceSpendingLimit}
            handlers={handlers}
        />
    );
};

export default CardRejectedPassedKycContainer;
